module.exports = __webpack_public_path__ + "static/img/add-64px.1f481cda.png";